import {useEffect} from 'react';
import {hideLoading, showLoading} from '@Libraries/loading-toast-library';
import {useAppSelector} from '@/hooks';

interface UseToggleLoadingNotificationProps {
  panelId: string;
  loadingKey: string;
  loadingText?: string;
  showLoadingState?: boolean;
}

const useToggleLoadingNotificationOnPanelOpenClose = ({panelId, loadingKey, loadingText = 'Loading...', showLoadingState = true}: UseToggleLoadingNotificationProps): void => {
  const isPanelClosed = useAppSelector((state) => {
    return state.panels.panelHashmap[panelId]?.closed;
  });

  useEffect(() => {
    hideLoading(loadingKey);

    if (isPanelClosed === undefined && showLoadingState) {
      showLoading(loadingKey, {
        text: loadingText,
      });
    } else {
      hideLoading(loadingKey);
    }
  }, [isPanelClosed, showLoadingState, loadingKey, loadingText]);
};

export default useToggleLoadingNotificationOnPanelOpenClose;
